




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import { getAllClients } from "@/api/client-api";

export interface SearchProjectQuery {
  keyword: string;
  client: string; // company id

  // TODO: statusも設定できるようにする？
}

@Component({})
export default class SearchProjectBar extends Vue {
  @Prop({ default: () => ({}) }) defaultValues!: SearchProjectQuery;

  data: SearchProjectQuery = {
    keyword: "",
    client: ""
  };
  clientOptions: SelectOption[] = [];

  public mounted() {
    this.getClientOptions().then(options => {
      this.clientOptions = [
        {
          text: "すべての発注者",
          value: ""
        }
      ].concat(options);
    });
  }

  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged() {
    Object.assign(this.data, this.defaultValues);
  }

  search() {
    this.$emit("search", this.data);
  }

  async getClientOptions(): Promise<SelectOption[]> {
    return (await getAllClients()).map(c => ({
      text: c.name,
      value: String(c.id)
    }));
  }
}
